import SEO from "./SEO";
import { ReactNode } from "react";

interface PageProps {
  title: string;
  description: string;
  children: ReactNode;
  image?: string;
  keywords?: string[];
  structuredData?: Record<string, any>;
  canonicalUrl?: string;
  author?: string;
  noindex?: boolean;
  facebookAppId?: string;
  twitterUsername?: string;
}

const Page = ({ 
  title, 
  description, 
  children, 
  image,
  keywords = [],
  structuredData,
  canonicalUrl,
  author,
  noindex,
  facebookAppId,
  twitterUsername
}: PageProps) => {
  return (
    <>
      <SEO 
        title={title} 
        description={description} 
        image={image}
        keywords={keywords}
        structuredData={structuredData}
        canonicalUrl={canonicalUrl}
        author={author}
        noindex={noindex}
        facebookAppId={facebookAppId}
        twitterUsername={twitterUsername}
      />
      {children}
    </>
  );
};

export default Page;